function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  id: "paypal"
}, React.createElement("g", null, React.createElement("path", {
  d: "M569.759,137.57C560.51,49.851,489.069,0,370.426,0H137.019L16.128,544.038h79.544L73.395,644.256h215.454 l31.812-143.168h107.032c111.027,0,200.436-133.146,200.436-243.386C628.128,206.119,607.884,164.701,569.759,137.57z M51.82,515.404L159.998,28.634h210.428c64.153,0,171.802,16.736,171.802,128.851c0,96.667-79.272,214.751-171.802,214.751 H240.429l-31.812,143.168H51.82z M427.692,472.454H297.696l-31.812,143.168H109.087l15.906-71.584h106.589l31.812-143.168 h107.033c105.028,0,190.585-119.116,199.547-225.303c19.515,20.831,29.521,48.291,29.521,82.135 C599.494,354.369,520.223,472.454,427.692,472.454z M306,259.005c63.48,0,93.06-60.116,93.06-101.062 c0-43.867-62.837-43.408-96.582-43.408h-14.746l-35.449,141.994l16.55,1.103C279.285,258.633,297.167,259.005,306,259.005z M310.109,142.28c21.017,0.215,60.302,1.847,60.302,15.205c0,25.412-18.898,72.887-64.425,72.887 c-4.582,0-11.167-0.1-17.724-0.315L310.109,142.28z"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "644.256px",
    height: "644.256px",
    viewBox: "0 0 644.256 644.256",
    style: {
      "enableBackground": "new 0 0 644.256 644.256"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/paypal-outlined-logo.68dc0d2d.svg";
export { SvgComponent as ReactComponent };